import React, { useState, useEffect } from "react";
import { component } from "picoapp";
import ReactDOM from "react-dom";
// import { Customizer } from "../Customizer";
import { createRoot } from "react-dom/client";




const initFormValues = {
  companyName: "",
  fName: "",
  lName: "",
  email: "",
  confirmEmail: "",
  product: {},
  customDesignProduct: {},
  quantity: 6,
  uploadedLogoName: "",
  uploadedLogo: "",
  logoDimensions: { width: 0, height: 0 },
  shippingRecipientName: "",
  shippingRecipientPhone: "",
  shippingAddress1: "",
  shippingAddress2: "",
  shippingCity: "",
  shippingState: "",
  shippingZip: "",
  billingRecipientName: "",
  billingRecipientPhone: "",
  billingAddress1: "",
  billingAddress2: "",
  billingCity: "",
  billingState: "",
  billingZip: ""
}

function BulkCustomizationForm() {
  const [formValues, setFormValues] = useState(initFormValues);
  // const [activeStep, setActiveStep] = useState(1);


  const handleChange = (e) => {
    setFormValues({...formValues, [e.target.name]: e.target.value})
  }
  return (
    <div>
      {/* <ProgressBar activeStep={activeStep}/> */}
      <div>
        {/* {activeStep === 1 && 
          <StepOne handleChange={handleChange} formValues={formValues} setActiveStep={setActiveStep}/>
        } */}
          <StepTwo formValues={formValues} handleChange={handleChange} setFormValues={setFormValues} initFormValues={initFormValues}/>
        {/* {activeStep === 3 && 
          <StepThree formValues={formValues} handleChange={handleChange} setFormValues={setFormValues} initFormValues={initFormValues} setActiveStep={setActiveStep}/>
        } */}
        {/* {activeStep === 4 && 
          <StepFour formValues={formValues} handleChange={handleChange} setFormValues={setFormValues} initFormValues={initFormValues} setActiveStep={setActiveStep}/>
        } */}
      </div>
    </div>
  )
}
// function ProgressBar({activeStep}) {
//   return (
//     <div>
//       <div className="step-container">
//         <div className="progressBar-step">
//           <span>1</span>
//           <span>Your information</span>
//         </div>
//         <div className="progressBar-step">
//           <span>2</span>
//           <span>Select a Product</span>
//         </div>
//         <div className="progressBar-step">
//           <span>3</span>
//           <span>Shipping & Billing Information</span>
//         </div>
//         <div className="progressBar-step">
//           <span>4</span>
//           <span>Review</span>
//         </div>
//       </div>
//       <div className="progress-container">
//         <div className="progress-bar" style={{ width: `${(activeStep / 4) * 100}%` }}></div>
//       </div>
//     </div>
//   )
// }
function StepOne({handleChange, formValues, setActiveStep}) {
  return (
    <div className="form-stepOne form-step">
      <div className="form-field">
        <label htmlFor="companyName">
          Company Name
        </label>
        <input type="text" name="companyName" value={formValues.companyName} onChange={(e) => handleChange(e)}/>
      </div>
      <div className="form-twoColumn">

        <div className="form-field">
          <label htmlFor="fName">
            First Name
          </label>
          <input type="text" name="fName" value={formValues.fName} onChange={(e) => handleChange(e)}/>
        </div>
        <div className="form-field">
          <label htmlFor="lName">
            Last Name
          </label>
          <input type="text" name="lName" value={formValues.lName} onChange={(e) => handleChange(e)}/>
        </div>
      </div>

      <div className="form-twoColumn">
        <div className="form-field">
          <label htmlFor="email">
            Business Email
          </label>
          <input type="email" name="email" value={formValues.email} onChange={(e) => handleChange(e)}/>
        </div>
        <div className="form-field">
          <label htmlFor="confirmEmail">
            Confirm Business Email
          </label>
          <input type="email" name="confirmEmail" value={formValues.confirmEmail} onChange={(e) => handleChange(e)}/>
        </div>
      </div>
      <div>Heads up: by providing your email address below, you're also signing up to receive future corporate sales marketing emails from us.</div>
      <button
      className="button" 
      disabled={
        !formValues.companyName || 
        !formValues.fName || 
        !formValues.lName || 
        !formValues.email || 
        !formValues.confirmEmail || 
        formValues.email !== formValues.confirmEmail
        } 
        onClick={() => setActiveStep(2)}
      >
        Next Step
      </button>
    </div>
  )
}
function StepTwo({formValues, handleChange, setFormValues}) {
  return (
    <Customizer formValues={formValues} handleChange={handleChange} setFormValues={setFormValues} initFormValues={initFormValues}/>
  )
}
function StepThree({handleChange, formValues, setActiveStep}) {
  return (
    <div className="form-stepOne form-step">
      <div className="form-twoColumn">
        <div className="form-field">
          <label htmlFor="shippingRecipientName">
            Recipient Name
          </label>
          <input type="text" name="shippingRecipientName" value={formValues.shippingRecipientName} onChange={(e) => handleChange(e)}/>
        </div>

        <div className="form-field">
          <label htmlFor="shippingRecipientPhone">
            Recipient Phone
          </label>
          <input type="tel" name="shippingRecipientPhone" value={formValues.shippingRecipientPhone} onChange={(e) => handleChange(e)}/>
        </div>
      </div>

      <div className="form-field">
        <label htmlFor="shippingAddress1">
          Address Line 1
        </label>
        <input type="text" name="shippingAddress1" value={formValues.shippingAddress1} onChange={(e) => handleChange(e)}/>
      </div>
      <div className="form-field">
        <label htmlFor="shippingAddress2">
          Address Line 2
        </label>
        <input type="text" name="shippingAddress2" value={formValues.shippingAddress2} onChange={(e) => handleChange(e)}/>
      </div>

      <div className="form-threeColumn">
        <div className="form-field">
          <label htmlFor="shippingCity">
            City
          </label>
          <input type="text" name="shippingCity" value={formValues.shippingCity} onChange={(e) => handleChange(e)}/>
        </div>
        <div className="form-field">
          <label htmlFor="shippingState">
            State
          </label>
          <input type="text" name="shippingState" value={formValues.shippingState} onChange={(e) => handleChange(e)}/>
        </div>
        <div className="form-field">
          <label htmlFor="shippingZip">
            Zip
          </label>
          <input type="text" name="shippingZip" value={formValues.shippingZip} onChange={(e) => handleChange(e)}/>
        </div>
      </div>
      <div>Heads up: by providing your email address below, you're also signing up to receive future corporate sales marketing emails from us.</div>
      <button
      className="button" 
      disabled={
        !formValues.shippingRecipientName || 
        !formValues.shippingRecipientPhone || 
        !formValues.shippingAddress1 || 
        !formValues.shippingCity || 
        !formValues.shippingState || 
        !formValues.shippingZip
        } 
        onClick={() => setActiveStep(4)}
      >
        Next Step
      </button>
    </div>
  )
}
function StepFour({formValues}) {
  return (
    <div>
      <div>
        <span>Company Information</span>
        <div>
          <div>Company Name</div>
          <div>{formValues.companyName}</div>
        </div>
        <div>
          <div>Name</div>
          <span>{formValues.fName}</span>
          <span>{formValues.lName}</span>
        </div>
        <div>
          <div>Business Email</div>
          <div>{formValues.email}</div>
        </div>
        <span>Shipping Address</span>
        <div>
          <div>Recipient Name</div>
          <div>{formValues.shippingRecipientName}</div>
        </div>
        <div>
          <div>Recipient Phone</div>
          <div>{formValues.shippingRecipientPhone}</div>
        </div>
        <div>
          <div>Address</div>
          <div>{formValues.shippingAddress1}</div>
        </div>
        <div>
          <div>City</div>
          <div>{formValues.shippingCity}</div>
        </div>
        <div>
          <div>State</div>
          <div>{formValues.shippingState}</div>
        </div>
        <div>
          <div>Zip Code</div>
          <div>{formValues.shippingZip}</div>
        </div>
      </div>
    </div>
  )
}
export default component((node, ctx) => {
  const element = <BulkCustomizationForm node={node} ctx={ctx} />;
  const root = createRoot(node);
  root.render(element);

  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});